import {ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {SessionActions} from "../../../shared/actions";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";

@Component({
  selector: 'vb-temperature-log-entries-list',
  templateUrl: './temperature-log-entries-list.component.html',
  styleUrls: ['./temperature-log-entries-list.component.css']
})
export class TemperatureLogEntriesListComponent extends AbstractListView implements OnInit {

  @Input()
  tempLogEntries = [];

  @ViewChild('table')
  datatable: DatatableComponent;

  @ViewChild('formatTemperatureTmpl')
  formatTemperatureTmpl: TemplateRef<any>;

  @ViewChild('notificationsTmpl')
  notificationsTmpl: TemplateRef<any>;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.columns = [
      {prop: 'created_at', name: 'Zeitstempel', cellTemplate: this.datatable.formatDateTimeTmpl, flexGrow: 2},
      {name: 'Temperatur', cellTemplate: this.formatTemperatureTmpl, flexGrow: 2},
      {name: 'Status', cellTemplate: this.notificationsTmpl, sortable: false, maxWidth: '100px', flexGrow: 1}
    ];

  }

  onCellUpdate(row, res, index) {
  }

}



// WEBPACK FOOTER //
// ./src/app/sensors/components/temperature-log-entries-list/temperature-log-entries-list.component.ts